<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, handleBlur, validate, errorMessage }">
      <Dropdown
        :modelValue="value"
        @update:modelValue="handleChange"
        @blur="handleBlur"
        @hide="validate"
        :class="{ 'p-invalid': errorMessage }"
        :virtualScrollerOptions="virtualScrollerOptions"
        v-bind="$attrs"
        ref="dropdown"
      >
        <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
          <slot v-if="slot" :name="slot" v-bind="scope" />
        </template>

        <template v-slot:loader="{ options }" v-if="$slots.loader">
          <slot name="loader" :options="options"></slot>
        </template>

        <template v-if="label" #label>{{ label }}</template>
        <template v-if="errorMessage" #helperText>{{ errorMessage }}</template>
      </Dropdown>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Dropdown } from './../../../core/controls';
import { FieldValidator } from './../field-validator';

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  virtualScrollerOptions: {
    type: Object,
  },
});

const dropdown = ref<InstanceType<typeof Dropdown>>();

defineExpose({ hide: () => dropdown.value?.dropdown?.hide() });
</script>
